import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MbscDateType } from '@mobiscroll/angular';

@Injectable({
  providedIn: 'root'
})
export class DateChangeService {

  selectedDateSource = new BehaviorSubject<MbscDateType | null>(null);

  selectedDate$ = this.selectedDateSource.asObservable();


  setSelectedDate(date: MbscDateType) {
    const current = this.selectedDateSource.value;

    if (this.isSameDate(current, date)) {
      return;
    }

    this.selectedDateSource.next(date);
  }


  private isSameDate(a: MbscDateType | null, b: MbscDateType): boolean {
    if (!a || !b) return false;

    const da = new Date(a as any).getTime();
    const db = new Date(b as any).getTime();

    return da === db;
  }
}
